import { MapPin } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Logo } from "./Logo";
import { useLang } from "../../i18n";

export const LegalDialog = ({ open, onClose }) => {
  const { t } = useLang();
  const doc = open ? t.footer.legal[open] : null;
  return (
    <Dialog open={!!open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="legal-dialog" className="max-h-[85vh] overflow-y-auto rounded-3xl border-[#A69B8F]/30 bg-[#FDFBF7] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold text-[#2D2D2D]">{doc?.t}</DialogTitle>
          <DialogDescription className="text-xs uppercase tracking-widest text-[#7a7065]">Fes Espai Olot · RGPD</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm leading-relaxed text-[#4a433c]">
          {doc?.p.map((p) => <p key={p}>{p}</p>)}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const Footer = ({ onLegal }) => {
  const { t } = useLang();
  return (
  <footer data-testid="site-footer" className="grain relative overflow-hidden bg-[#1f1f1f] pb-28 pt-20 text-[#D9D2C8] md:pb-10">
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <Logo dark size="lg" />
          <p className="mt-6 flex items-center gap-2 text-sm"><MapPin className="h-4 w-4 text-[#F26D5A]" /> Olot (Girona)</p>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-3 text-sm">
          {Object.entries(t.footer.legal).map(([k, v]) => (
            <button key={k} onClick={() => onLegal(k)} data-testid={`footer-legal-${k}`} className="link-underline hover:text-white">{v.t}</button>
          ))}
        </nav>
      </div>
      <p className="font-display pointer-events-none mt-16 select-none whitespace-nowrap text-[18vw] font-extrabold leading-[0.8] tracking-tighter text-[#2a2a2a] md:text-[13vw]" aria-hidden="true">
        FES ESPAI
      </p>
      <div className="mt-8 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-[#B5ACA2] sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Fes Espai Olot. {t.footer.rights}</span>
        <span>{t.footer.tagline}</span>
      </div>
    </div>
  </footer>
  );
};
